<mat-menu
  #agentStatus="matMenu"
  class="status-menu-core {{ (isDarkMode$ | async) ? 'dark-theme-portal-base' : '' }}"
  [overlapTrigger]="false"
>
  <ng-container *ngTemplateOutlet="menuList"></ng-container>
</mat-menu>

<ng-template #menuList>
  <ng-container *ngIf="meCallcenter">
    <ng-container
      *ngIf="
        meCallcenter.systemStatus !== SystemStatusCode.free && meCallcenter.systemStatus !== SystemStatusCode.dialing
      "
    >
      <ng-container *ngIf="meCallcenter.systemStatus === SystemStatusCode.acw; else dialing">
        <ng-container *ngIf="meCallcenter?.assignedTxn?.queue?.agentWorkflowConfig?.disablePopup">
          <button mat-menu-item color="primary" (click)="acwCall.emit(meCallcenter)">
            <div class="flex justify-start items-center gap-2">
              <mat-icon class="s-20 end_acw"> published_with_changes </mat-icon>
              <span>End ACW</span>
            </div>
          </button>
        </ng-container>
      </ng-container>
      <ng-template #dialing>
        <ng-container *ngIf="meCallcenter.systemStatus === SystemStatusCode.talking">
          <button mat-menu-item color="primary" (click)="endCall.emit(meCallcenter)">
            <div class="flex justify-start items-center gap-2">
              <mat-icon class="s-20 b3n-text-error" svgIcon="b3n_call_end"> </mat-icon>
              <span>End call</span>
            </div>
          </button>
        </ng-container>
      </ng-template>
    </ng-container>

    <button mat-menu-item color="primary" (click)="changeStatus(AgentStatus.available, meCallcenter.status)">
      <div class="flex justify-start items-center gap-2">
        <csh-state-icon-frame [status]="AgentStatus.available" [width]="20"></csh-state-icon-frame>
        <span>Available</span>
        <mat-pseudo-checkbox
          *ngIf="meCallcenter.status === AgentStatus.available"
          [state]="'checked'"
          appearance="minimal"
          class="ml-6"
        ></mat-pseudo-checkbox>
      </div>
    </button>
    <button
      mat-menu-item
      color="primary"
      [matTooltip]="meCallcenter?.busyReason"
      matTooltipPosition="after"
      (click)="changeStatus(AgentStatus.busy, meCallcenter.status)"
    >
      <div class="flex justify-start items-center gap-2">
        <csh-state-icon-frame [status]="AgentStatus.busy" [width]="20"></csh-state-icon-frame>
        <span>Busy</span>
        <mat-pseudo-checkbox
          *ngIf="meCallcenter.status === AgentStatus.busy"
          [state]="'checked'"
          appearance="minimal"
          class="ml-6"
        ></mat-pseudo-checkbox>
      </div>
    </button>
    <button mat-menu-item color="primary" (click)="changeStatus(AgentStatus.dnd, meCallcenter.status)">
      <div class="flex justify-start items-center gap-2">
        <csh-state-icon-frame [status]="AgentStatus.dnd" [width]="20"></csh-state-icon-frame>
        <span>Away</span>
        <mat-pseudo-checkbox
          *ngIf="meCallcenter.status === AgentStatus.dnd"
          [state]="'checked'"
          appearance="minimal"
          class="ml-6"
        ></mat-pseudo-checkbox>
      </div>
    </button>
    <button mat-menu-item color="primary" (click)="changeStatus(AgentStatus.offline, meCallcenter.status)">
      <div class="flex justify-start items-center gap-2">
        <csh-state-icon-frame [status]="AgentStatus.offline" [width]="20"></csh-state-icon-frame>
        <span>Offline</span>
        <mat-pseudo-checkbox
          *ngIf="meCallcenter.status === AgentStatus.offline"
          [state]="'checked'"
          appearance="minimal"
          class="ml-6"
        ></mat-pseudo-checkbox>
      </div>
    </button>
  </ng-container>
</ng-template>
